// assets/js/timeline.js
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const isEditor = document.body.classList.contains("wp-admin");
if (!isEditor) gsap.registerPlugin(ScrollTrigger);

function initTimeline(section) {
  if (!section || section.__timelineInit) return;
  section.__timelineInit = true;

  const grid = section.querySelector(".timeline__grid");
  const fill = section.querySelector(".timeline__rail-fill");

  if (!isEditor && grid && fill) {
    gsap.set(fill, { scaleY: 0, transformOrigin: "top" });

    ScrollTrigger.create({
      trigger: grid,
      start: "top 20%",
      end: "bottom 75%",
      scrub: true,
      onUpdate: (self) => {
        gsap.set(fill, { scaleY: self.progress });
      },
    });
  }

  const rows = section.querySelectorAll(".timeline__row");
  rows.forEach((row) => {
    const title = row.querySelector(".timeline__title");
    const text = row.querySelector(".timeline__text");
    const year = row.querySelector(".timeline__year");
    const photo = row.querySelector(".timeline__photo");
    const img = row.querySelector(".timeline__photo img");

    gsap.set([title, text, year], { opacity: 0, y: 16 });
    if (photo) gsap.set(photo, { opacity: 0, y: 14 });
    if (img) gsap.set(img, { scale: 1.06 });

    const tlOpts = isEditor
      ? { defaults: { ease: "power3.out" } }
      : {
          defaults: { ease: "power3.out" },
          scrollTrigger: {
            trigger: row,
            start: "top 80%",
            once: true,
          },
        };

    const tl = gsap.timeline(tlOpts);

    if (year) tl.to(year, { opacity: 1, y: 0, duration: 0.35 });
    if (title) tl.to(title, { opacity: 1, y: 0, duration: 0.6 }, "-=0.1");
    if (text) tl.to(text, { opacity: 1, y: 0, duration: 0.55 }, "-=0.3");

    if (photo) {
      tl.to(photo, { opacity: 1, y: 0, duration: 0.55 }, "-=0.35");
      if (img)
        tl.to(img, { scale: 1, duration: 0.85, ease: "power2.out" }, "<");
    }

    if (!isEditor && photo) {
      gsap.to(photo, {
        y: -10,
        ease: "none",
        scrollTrigger: {
          trigger: row,
          start: "top bottom",
          end: "bottom top",
          scrub: 0.35,
        },
      });
    }
  });
}

const mount = () => {
  if (!isEditor) {
    document.querySelectorAll(".timeline").forEach(initTimeline);
    return;
  }

  const root = document.querySelector(".editor-styles-wrapper") || document;
  const run = () => root.querySelectorAll(".timeline").forEach(initTimeline);

  run();

  const mo = new MutationObserver(run);
  mo.observe(root, { childList: true, subtree: true });
};

if (window.wp?.domReady) window.wp.domReady(mount);
else document.addEventListener("DOMContentLoaded", mount);
